import React, {useContext, useEffect} from "react";
import { Row, Col, Button, Container } from "react-bootstrap";
import { Link , useHistory } from "react-router-dom";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import getNextPage from "./getNextPage";
import {RouterContext} from "./Onboarding"

export default function NotComplete(props) {
  let history = useHistory();
  const route = useContext(RouterContext)

  let chevronRight = require("images/onboarding/chevronRight.png");
  chevronRight = <img style={{paddingBottom:"3px", paddingLeft:"12px"}} src={`/datapulse${chevronRight}`} />;
  
  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem(
      "routerHistory",
      JSON.stringify([...route.get])
    );
  }, [route.get]);
  props.pageLocator();
  let caution = require("images/icons/exclaim-triangle.png");
  caution = (
    <img className="px-4 d-lg-inline-block d-block mx-auto mb-3 mb-lg-0" src={`/datapulse${caution}`} />
  );
  let mobileHideCaution = require("images/icons/exclaim-triangle.png");
  mobileHideCaution = (
    <img className="px-4 d-lg-inline-block d-none" src={`/datapulse${mobileHideCaution}`} />
  );
  return (
    <Container fluid className="px-lg-5 px-0">
      <Row className="px-lg-4 px-0 mb-3 pb-3 justify-content-center text-center">
        <Col md={12}>
          <span>
            {caution}{" "}
            <p className="pb-3 f28 visby-bold light-primary d-lg-inline-block">
              Onboarding is not yet completed
            </p>
            {mobileHideCaution}
          </span>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md={10}>
          {/*
          <div className="mb-5 text-center">
            <span>
              {caution}{" "}
              <p className="pb-3 f28 visby-bold light-primary d-inline-block">
                Onboarding is not yet completed
              </p>
              {mobileHideCaution}
            </span>
          </div> */}
          <div>
            <p className="f16 nunito-regular mb-5 light-primary px-lg-5 px-0">
              There are steps that were skipped that still need to be
              completed to finish onboarding. Until those are done, "Complete Onboarding" will continue to remain for this client in the left
              navigation of DataPulse.{" "}<br></br><br></br>
              <strong>
                To complete the skipped onboarding sections please click the "Finish Onboarding"
                button below now, or click "Complete Onboarding" in the left
                navigation at any time.
              </strong>
            </p>
          </div>
        </Col>
      </Row>
      <input
        hidden
        name="current_onboarding_page"
        value={window.location.href}
        readOnly
        />
      <Row className="mt-5 justify-content-center">
        <Col>
          <div className="navButtonRow">
            <NextButton
              validated={true} 
              btnText={`Finish Onboarding`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
